
<template>
  <div class="frame flex-col">
    <div class="frame-title">
      <div class="text">
        {{title}}
      </div>
    </div>
    <div class="flex-1 slotbox">
      <!-- <img src="@/assets/home/jiao.png" class="c-1">
      <img src="@/assets/home/jiao.png" class="c-2">
      <img src="@/assets/home/jiao.png" class="c-3">
      <img src="@/assets/home/jiao.png" class="c-4"> -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'frame',
    components: {},
    props: ['title'],
    data() {
      return {}
    },
    watch: {},
    computed: {},
    methods: {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    destroyed() {}
  }
</script>
<style lang='scss' scoped>
  .frame {
    width: 100%;
    height: 100%;
    position: relative;
    .frame-title {
      width: 100%;
      height: 50px;
      background-image: url('../assets/home/frame-bg.png');
      background-size: 100% 100%;
      line-height: 42px;
      letter-spacing: 1px;
      padding-left: 90px;
      .text {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
    .slotbox{
      width: 100%;
      position: relative;
      background-color: #091A35;
    }
    .c-1 {
      position: absolute;
      top: 0;
      left: 0;
      transform: rotate(180deg);
      width: 16px;
      height: 16px;
      z-index: 23;
    }

    .c-2 {
      position: absolute;
      top: 0;
      right: 0;
      transform: rotate(270deg);
      width: 16px;
      height: 16px;
      z-index: 23;
    }

    .c-3 {
      position: absolute;
      bottom: 0;
      left: 0;
      transform: rotate(90deg);
      width: 16px;
      height: 16px;
      z-index: 23;
    }

    .c-4 {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 16px;
      height: 16px;
      z-index: 23;
    }
  }
</style>
